<template>
    <div v-if="product">

        <!--grid-client-review :product="product"></grid-client-review-->

        <carousel-list-grids :title="title"></carousel-list-grids>

        <!--users-rankings :product-id="product.id"></users-rankings-->

        <!--grid-client-question :product-id="product.id"></grid-client-question-->

    </div>
</template>

<script>
    import ProductService from '../../../providers/api/product-service';
    import GridClientReview from "../../grids/grid-client-review";
    import CarouselListGrids from "../../carousel-list-grids";
    import UsersRankings from "../../users-rankings";
    import GridClientQuestion from "../../grids/grid-client-question";

    const productService = new ProductService();

    export default {
        name: "page-product-index",
        components: {GridClientQuestion, UsersRankings, CarouselListGrids, GridClientReview},
        props: ['productId', 'title'],
        data: () => {
            return {
                product: null
            }
        },
        mounted() {
            this.getProduct();
            this.viewProduct();
        },
        methods: {
            getProduct() {
                productService.doGetProductById(this.productId)
                    .then((res) => this.product = res.data.data);
            },
            viewProduct() {
                productService.doRegisterView(this.productId);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// resources/site/js/components/pages/product/index.vue